<section class="main-section">
  <a class="w-full justify-items-center" [routerLink]="'home'">
    <img class="w-10 select-none drop-shadow-md" src="./assets/images/rvs-logo.svg">
  </a>
  <h1 class="title-container">
    <span class="text-gray-900">{{titleStart()}}</span>
    <span class="text-gray-600">{{titleEnd()}}</span>
  </h1>
</section>

<div class="user-menu-container">
  @if (hasUser()) {
    @let admin = isAdministrator();

    <button mirButton ghost
        class="group-[.admin]/ShellHeader:font-semibold"
        [attr.blue-dark]="admin || null"
        [matMenuTriggerFor]="menu"
        [title]="'Shell.Settings' | translate">
      {{fullName()}}
      <MirIcon>{{userIcon()}}</MirIcon>
    </button>
  }
  @else {
    <MirIcon class="animate-pulse pr-4" color="slate">globe</MirIcon>
  }
</div>

<mat-menu #menu="matMenu" yPosition="above" xPosition="before">
  <button mat-menu-item
      (click)="handleOpenSettings()">
    <MirIcon>settings</MirIcon>
    {{'Shell.Settings' | translate}}
  </button>
  <button mat-menu-item
      (click)="handleLogout()">
    <MirIcon>logout</MirIcon>
    {{'Shell.Logout' | translate}}
  </button>
</mat-menu>
